import React from "react";
import { useAuthStore } from "../../../store";

function useServiceProvider() {
  const serviceProvider = useAuthStore((state) => state.user);
  return React.useMemo(() => serviceProvider, [serviceProvider]);
}

export default useServiceProvider;
